<i18n src="@/locales/models/harvested_batch.yml" lang="yaml"></i18n>
<template>
  <label class="label-form">
    {{ $t("model.harvested_batch.harvest_team") }}
  </label>
  <div class="mt-1 hidden sm:block">
    <select-form :options="options" v-model="id" class=""/>
  </div>
  <div class="mt-1 sm:hidden">
    <div class="flex full flex-wrap items-stretch">
      <input type="text" v-model="label" :class="['input-text-append']" :disabled="show_options" @click.prevent="display()" />
      <span class="input-append">
        <template v-if="id != null">
          <i class="fa-solid fa-xmark hover:cursor-pointer"  @click.prevent="cancel"></i>
          <span class="space-icon"></span>
        </template>
        <i v-if="show_options" class="fa-solid fa-chevron-up hover:cursor-pointer" @click.prevent="hide"></i>
        <i v-else class="fa-solid fa-chevron-down hover:cursor-pointer" @click.prevent="display"></i>
      </span>
    </div>
    <fieldset v-if="show_options" class="grid gap-y-2 my-2">
      <div v-for="(option, index) in options" :key="index" @click.prevent="select(option)" >
        <input type="radio" :id="`harvest_team_${option.id}`" :name="`harvest_team_${option.id}`"
          :value="option.id" v-model="id" />
        <label class="ml-2" :for="`harvest_team_${option.id}`">{{ option.name }}</label>
      </div>
    </fieldset>
  </div>
</template>

<script>
export default {
  props: {
    options: { type: Array, required: true },
    modelValue: {},
  },
  data() {
    return {
      id: this.modelValue,
      show_options: false,
      label: ""
    }
  },
  watch: {
    id: function (newValue) {
      let option = this.findOption(newValue);
      this.label = option?.name || "";
      this.$emit('update:modelValue', newValue);
    }
  },
  computed: {
    option_selected: function () {
      return this.findOption(this.id);
    },
  },
  mounted() {
    if (this.option_selected) {
      this.label = this.option_selected.name;
    }
  },
  methods: {
    findOption: function (id) {
      let option = this.options.find(o => o.id == id);
      return option || null;
    },
    cancel: function () {
      this.hide();
      this.clean();
    },
    clean: function () {
      this.id = null;
      this.label = "";
    },
    display: function () {
      this.show_options = true;
    },
    hide: function () {
      this.show_options = false;
    },
    select: function (option) {
      this.id = option?.id || null;
      this.label = option?.name || "";
      this.hide();
    }
  }
}
</script>
